import { render, staticRenderFns } from "./videoInfo.vue?vue&type=template&id=f140c1c2&scoped=true&"
import script from "./videoInfo.vue?vue&type=script&lang=js&"
export * from "./videoInfo.vue?vue&type=script&lang=js&"
import style0 from "./videoInfo.vue?vue&type=style&index=0&id=f140c1c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140c1c2",
  null
  
)

export default component.exports